import axios from 'axios'
import qs from 'qs';
import { getApiUrl, getUploadImageBaseUrl } from '../config';
import { createGetUrl, getSession } from '../libs/utils'
import { downLoadFile } from './utils'
import { isObject } from 'lodash'

axios.defaults.timeout = 2 * 1000 * 60

// 请求拦截器
axios.interceptors.request.use(
  config => {
    return config
  },
  error => {
    // 发送失败
    return error
  }
)

// 响应拦截器
axios.interceptors.response.use(
  response => {
    const dataAxios = response.data
    const { code, message } = dataAxios
    if (code && (code.toString() === '10001' || code.toString() === '10002')) {
      sessionStorage.clear()
      window.location.replace('/login')
      throw Error(message)
    }
    return dataAxios
  },
  error => {
    if (error && error.response) {
      switch (error.response.status) {
        case 400:
          error.message = '请求参数传入错误';
          break
        case 401:
          error.message = '未授权，请登录';
          break
        case 403:
          error.message = '拒绝访问';
          break
        case 404:
          error.message = `请求地址出错: ${error.response.config.url}`;
          break
        case 408:
          error.message = '请求超时';
          break
        case 500:
          error.message = '服务器内部错误';
          break
        case 501:
          error.message = '服务未实现';
          break
        case 502:
          error.message = '网关错误';
          break
        case 503:
          error.message = '服务不可用';
          break
        case 504:
          error.message = '网关超时';
          break
        case 505:
          error.message = 'HTTP版本不受支持';
          break
        default:
          error.message = `错误状态码:${error.response.status}`
          break
      }
    }
    return error
  }
)

function setHttpConfig (config) {
  let risUserInfo = getSession('risUserInfo', 'object') || null
  if (risUserInfo && risUserInfo.userToken) {
    config.headers.userToken = risUserInfo.userToken
  }
  config.headers.systemType = 'ris'
  return config
}


async function httpRequest(url, method, data, config) {
  if (!url) {
    throw Error('请求地址错误')
  }
  config = setHttpConfig(config)
  if (config.requestUpload) {
    url = getUploadImageBaseUrl() + url
    delete config.requestUpload
  } else {
    url = getApiUrl() + url
  }
  try {
    if (method === 'get') {
      let getUrl = createGetUrl(url, data)
      return await axios.get(getUrl, config)
    }
    if (method === 'post') {
      return await axios.post(url, data, config)
    }
  } catch (error) {
    return error || {}
  }
}

function dealHttpRequestConfig (dealConfig, header, extConf) {
  let config = {
    headers: dealConfig.headers
  }
  if (header && isObject(header)) {
    let arr = Object.keys(header)
    if (arr.length > 0) {
      config.headers = Object.assign({}, config.headers, header)
    }
  }
  if (extConf && isObject(extConf)) {
    let extKeys = Object.keys(extConf)
    if (extKeys.length > 0) {
      config = Object.assign({}, config, extConf)
    }
  }
  return config
}


const request = {
  async get(url, data, header = {}, extConf = {}) {
    if (!url) return alert("请求地址错误");
    let config = {
      headers: {
        "Content-Type": "application/x-www-form-urlencoded;charset=UTF-8",
        'Accept': 'application/json'
      }
    }
    config = dealHttpRequestConfig(config, header, extConf)
    return await httpRequest(url, 'get', data, config)
  },
  async post(url, data, header = {}, extConf = {}) {
    let config = {
      headers: {
        "Content-Type": "application/x-www-form-urlencoded;charset=UTF-8",
        'Accept': 'application/json'
      }
    }
    config = dealHttpRequestConfig(config, header, extConf)
    return await httpRequest(url, 'post', qs.stringify(data), config)
  },
  async postJson (url, data) {
    let config = {
      headers: {
        'Content-Type': 'application/json;charset=UTF-8',
        'Accept': 'application/json'
      }
    }
    let retData = await httpRequest(url, 'post', JSON.stringify(data), config)
    return retData
  },
  async postFile(url, data, header = {}, extConf = {}) {
    let config = {
      headers: { "Content-Type": "multipart/form-data" }
    };
    let dataParams = new FormData();
    for (let k in data) {
      dataParams.append(k, data[k]);
    }
    config = dealHttpRequestConfig(config, header, extConf)
    return httpRequest(url, 'post', dataParams, config)
  },
  async getJson (url) {
    return await axios.get(url)
  },
  // JSONP跨域请求
  async jsonp (url, params, callback) {
    return new Promise((resolve) => {
      let time = 8000 // 超时时间
      let timer = null
      let script = document.createElement('script')
      window[callback] = function (data) {
        if (timer) clearTimeout(timer)
        resolve(data)
        document.body.removeChild(script)
      }
      params = { ...params, callback }
      let arrs = []
      for (let key in params) {
        arrs.push(`${key}=${params[key]}`)
      }
      script.src = `${url}?${arrs.join('&')}`
      document.body.appendChild(script)
      timer = setTimeout(function () {
        window[callback] = null
        document.body.removeChild(script)
      }, time)
    })
  },
  // 获取图片base64
  async getBase64Image (url) {
    let data = await axios.get(url,{responseType: 'arraybuffer'})
    if (!data) return false
    return 'data:image/png;base64,' + btoa(new Uint8Array(data).reduce((data, byte) => data + String.fromCharCode(byte), ''))
  },
  // 下载文件
  async downLoad (url, fileName, type = 'get', params = null, config = {}) {
    let data = null
    if (type === 'get') {
      data = await axios.get(url, {responseType: 'blob'})
    } else if (type === 'post') {
      let conf = Object.assign(config, {responseType: 'blob'})
      conf = setHttpConfig(conf)
      data = await axios.post(url, params, conf)
    }
    let downLoadUrl = URL.createObjectURL(data)
    downLoadFile(downLoadUrl, fileName)
    URL.revokeObjectURL(downLoadUrl)
    return true
  }
}

export default request